import React, { Component } from 'react';
import { orderBy, without, find, findIndex, omit } from 'lodash';
import { Button } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import Choice from './Choice';

class KnowledgeCheckNew extends Component {
  constructor(props) {
    super(props);

    this.addChoice = this.addChoice.bind(this);
    this.updateChoice = this.updateChoice.bind(this);
    this.removeChoice = this.removeChoice.bind(this);
    this.getAdditionalIncorrectChoices =
      this.getAdditionalIncorrectChoices.bind(this);
    this.getAllIncorrectChoices = this.getAllIncorrectChoices.bind(this);
    this.getIncorrectChoice = this.getIncorrectChoice.bind(this);
    this.getCorrectChoice = this.getCorrectChoice.bind(this);
    this.renderAdditionalIncorrectChoices =
      this.renderAdditionalIncorrectChoices.bind(this);
  }

  addChoice(opts) {
    const params = {
      text: '',
      feedback: '',
      correct: opts.correct,
      position: opts.position,
    };

    request
      .postJSON(routes.QUESTIONS.NEW_CHOICE(this.props.questionId), params)
      .then(payload => {
        if (payload.success) {
          const choices = [...this.props.choices, payload.choice];
          this.props.applyChanges({ choices });
          this.props.handleUpdate({ choices });
        } else {
          /** @todo 'error' is set in state but we're not actually handling it */
          // eslint-disable-next-line react/no-unused-state
          this.setState({ error: true });
        }
      })
      /** @todo 'error' is set in state but we're not actually handling it */
      // eslint-disable-next-line react/no-unused-state
      .fail(() => this.setState({ error: true }));
  }

  updateChoice(choice, position) {
    const params = omit(choice, ['choice_path', 'id']);

    request.putJSON(choice.choice_path, params).then(payload => {
      if (payload.success) {
        const choices = [...this.props.choices];
        const choiceToUpdateIndex = findIndex(choices, ['position', position]);

        choices.splice(choiceToUpdateIndex, 1, choice);
        this.props.applyChanges({ choices: [...choices] });
        this.props.handleUpdate({ choices: [...choices] });
      } else {
        /** @todo 'error' is set in state but we're not actually handling it */
        // eslint-disable-next-line react/no-unused-state
        this.setState({ error: true });
      }
    });
  }

  removeChoice(choice) {
    request
      .delete(choice.choice_path)
      .then(payload => {
        if (payload.success) {
          const choices = without(this.props.choices, choice);

          // We're updating the Redux state and we need to ensure
          // that the choices are shallowly merged, which is why
          // we have `mergeChanges: false`. If it's not present,
          // then choices will never be removed from state.
          this.props.applyChanges({ choices }, { mergeChanges: false });
          this.props.handleUpdate({ choices });
        } else {
          /** @todo 'error' is set in state but we're not actually handling it */
          // eslint-disable-next-line react/no-unused-state
          this.setState({ error: true });
        }
      })
      /** @todo 'error' is set in state but we're not actually handling it */
      // eslint-disable-next-line react/no-unused-state
      .fail(() => this.setState({ error: true }));
  }

  getAllIncorrectChoices() {
    return orderBy(
      this.props.choices.filter(choice => !choice.correct),
      'position',
    );
  }

  getIncorrectChoice() {
    const incorrectChoices = this.getAllIncorrectChoices();
    const defaultChoice = {
      position: 2,
      correct: false,
      text: '',
      feedback: '',
    };

    return incorrectChoices.length ? incorrectChoices[0] : defaultChoice;
  }

  getAdditionalIncorrectChoices() {
    const incorrectChoices = this.getAllIncorrectChoices();
    return incorrectChoices.slice(1);
  }

  getCorrectChoice() {
    const correct = find(this.props.choices, 'correct');
    const defaultChoice = {
      position: 1,
      correct: true,
      text: '',
      feedback: '',
    };

    return correct || defaultChoice;
  }

  renderAdditionalIncorrectChoices(choices) {
    return choices.map((choice, index) => (
      <Choice
        choice={choice}
        onDelete={c => this.removeChoice(c)}
        onUpdate={c => this.updateChoice(c, choice.position)}
        key={`${choice.id}-${choice.position}`}
        aria-label={`${t('questions.choices.incorrect.additional_label')} ${
          index + 1
        }`}
      />
    ));
  }

  render() {
    const correctChoice = this.getCorrectChoice();
    const incorrectChoice = this.getIncorrectChoice();
    const additionalIncorrectChoices = this.getAdditionalIncorrectChoices();

    return (
      <div className="pt-8">
        <hr />
        <Choice
          choice={correctChoice}
          onUpdate={choice => this.updateChoice(choice, 1)}
          aria-label={t('questions.choices.correct.label')}
        />
        <Choice
          choice={incorrectChoice}
          onUpdate={choice => this.updateChoice(choice, 2)}
          aria-label={t('questions.choices.incorrect.label')}
        />
        {additionalIncorrectChoices.length > 0 &&
          this.renderAdditionalIncorrectChoices(additionalIncorrectChoices)}
        <Button
          icon="add"
          tall
          onClick={() =>
            this.addChoice({
              correct: false,
              position: this.props.choices.length + 1,
            })
          }
        >
          {t('questions.choices.add')}
        </Button>
      </div>
    );
  }
}

export default KnowledgeCheckNew;
